import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { cx, css } from 'emotion';
var anchorStyle = css({
  margin: 0,
  padding: 0,
  border: 0
});

var aTag = function aTag(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement("a", rest, children);
};

var buttonTag = function buttonTag(_ref2) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["children"]);

  return React.createElement("button", rest, children);
};

var Button =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Button, _PureComponent);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          href = _this$props.href,
          target = _this$props.target,
          type = _this$props.type,
          disabled = _this$props.disabled,
          blockLevel = _this$props.blockLevel,
          size = _this$props.size,
          onClick = _this$props.onClick,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["href", "target", "type", "disabled", "blockLevel", "size", "onClick", "className"]);

      if (process.env.NODE_ENV !== 'production' && (type === 'dark' || type === 'outline-dark')) {
        var message = "Warning: \"".concat(type, "\" value of \"type\" property for \"Button\" has been deprecated.\nPlease use a different value for \"type\"");
        console.warn(message);
      }

      var typeClasses = type === 'anchor' ? cx(anchorStyle, 'btn-link') : "btn btn-".concat(type);
      var classes = cx(className, typeClasses, _defineProperty({
        'btn-block': blockLevel
      }, "btn-".concat(size), size !== 'default'));
      return href ? aTag(_objectSpread({
        href: href,
        target: target,
        type: type,
        disabled: disabled,
        size: size,
        onClick: onClick,
        className: classes
      }, rest)) : buttonTag(_objectSpread({
        type: type,
        disabled: disabled,
        size: size,
        onClick: onClick,
        className: classes
      }, rest));
    }
  }]);

  return Button;
}(PureComponent);

export { Button as default };
Button.propTypes = {
  type: PropTypes.oneOf(['default', 'primary', 'dark', 'secondary', 'link', 'outline-dark', 'outline-secondary', 'anchor']),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_parent', '_self', '_top']),
  blockLevel: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'sm', 'lg']),
  onClick: PropTypes.func,
  className: PropTypes.string
};
buttonTag.propTypes = {
  children: PropTypes.node
};
aTag.propTypes = {
  children: PropTypes.node
};
Button.defaultProps = {
  type: 'default',
  disabled: false,
  blockLevel: false,
  size: 'default'
};